import type * as React from 'react'
import { GiveawayTheme, Maybe } from '@/types/codegen-contentful'

declare module 'react' {
  interface CSSProperties {
    [varName: `--${string}`]: string | number | undefined
  }
}

const defaultColors: React.CSSProperties = {
  '--giveaway-primary': '#333333',
  '--giveaway-secondary': '#cc0069',
  '--giveaway-primary-accent': '#4a4a4a',
}

export const getCustomColors = (theme?: Maybe<GiveawayTheme>): React.CSSProperties => {
  if (!theme) return defaultColors

  return {
    ...defaultColors,
    '--giveaway-primary': theme.primary ?? defaultColors['--giveaway-primary'],
    '--giveaway-secondary': theme.secondary ?? defaultColors['--giveaway-secondary'],
    '--giveaway-primary-accent': theme.primaryAccent ?? defaultColors['--giveaway-primary-accent'],
  }
}
